require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-singletons-and-swift.json") })
        }
      }, "path---blog-singletons-and-swift");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-singletons-and-swift!./.cache/json/blog-singletons-and-swift.json
// module id = 1065
// module chunks = 231608221292675